export const MYT_TZ = "Asia/Kuala_Lumpur";

const toDate = (d) => {
  if (!d) return null;
  const date = new Date(d);
  return Number.isNaN(date.getTime()) ? null : date;
};

// Date-time: "08 September 2026, 6:45 PM MYT" — always rendered in Malaysia time
// regardless of the viewer's device timezone. Input is a UTC ISO string from the API.
export const fmtMYT = (d, withTime = true) => {
  const date = toDate(d);
  if (!date) return "—";
  const datePart = date.toLocaleDateString("en-GB", { timeZone: MYT_TZ, day: "2-digit", month: "long", year: "numeric" });
  if (!withTime) return datePart;
  const timePart = date.toLocaleTimeString("en-US", { timeZone: MYT_TZ, hour: "numeric", minute: "2-digit", hour12: true });
  return `${datePart}, ${timePart} MYT`;
};

// Date only: "08 Sep 2026" (Malaysia time). Use for full ISO timestamps rendered as a date.
export const fmtMYTDate = (d) => {
  const date = toDate(d);
  if (!date) return "—";
  return date.toLocaleDateString("en-GB", { timeZone: MYT_TZ, day: "2-digit", month: "short", year: "numeric" });
};

// Relative time based on the true timestamp difference (timezone-independent): "5 minutes ago".
export const fmtRelative = (d) => {
  const date = toDate(d);
  if (!date) return "—";
  const diff = Date.now() - date.getTime();
  const abs = Math.abs(diff);
  const suffix = diff >= 0 ? "ago" : "from now";
  const mins = Math.round(abs / 60000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins} minute${mins === 1 ? "" : "s"} ${suffix}`;
  const hrs = Math.round(mins / 60);
  if (hrs < 24) return `${hrs} hour${hrs === 1 ? "" : "s"} ${suffix}`;
  const days = Math.round(hrs / 24);
  if (days < 30) return `${days} day${days === 1 ? "" : "s"} ${suffix}`;
  return fmtMYTDate(date);
};
